(function(){'use strict';

const PROXY='https://mandi-agent.vercel.app/api/chat';
const LEADS='https://hook.us2.make.com/lqze9zpvjxou65ouk7pz9moq5ina7txa';

function ga(n,p){try{if(typeof gtag==='function')gtag('event',n,Object.assign({event_category:'mandi_widget'},p||{}));}catch(e){}}

const CAT=[
  {id:'dbz-clasic',      name:'Chaqueta DBZ',          price:35,    variants:['Naranja','Negro','Azul','Rojo'],             sizes:['S','M','L','XL','2XL'],      img:'https://cdn.shopify.com/s/files/1/0689/5832/2781/files/goku-02.png?v=1746627152',e:'🐉'},
  {id:'dbz-goku',        name:'Camiseta DBZ Goku',     price:19.99, variants:['Única'],                                     sizes:['S','M','L','XL','2XL'],      img:'https://cdn.shopify.com/s/files/1/0689/5832/2781/files/mock_Mesadetrabajo1.png?v=1746648611',e:'🐉'},
  {id:'pr-red',          name:'Red Ranger',            price:39.99, variants:['Rojo'],                                      sizes:['S','M','L','XL','2XL'],      img:'https://cdn.shopify.com/s/files/1/0689/5832/2781/files/REDRANGER_Mesadetrabajo1.png?v=1746649096',e:'⚡'},
  {id:'pr-white',        name:'White Ranger',          price:39.99, variants:['Blanco'],                                    sizes:['S','M','L','XL','2XL'],      img:'https://cdn.shopify.com/s/files/1/0689/5832/2781/files/WhiteRANGER_Mesadetrabajo1.png?v=1746649095',e:'⚡'},
  {id:'pr-varsity',      name:'Power Rangers Varsity', price:35,    variants:['Vino/Negro'],                                sizes:['S','M','L','XL','2XL'],      img:'https://cdn.shopify.com/s/files/1/0689/5832/2781/files/POWER-24.png?v=1747521325',e:'⚡'},
  {id:'naruto-chaqueta', name:'Chaqueta Naruto Gold',  price:35,    variants:['Única'],                                     sizes:['S','M','L','XL','2XL'],      img:'https://cdn.shopify.com/s/files/1/0689/5832/2781/files/NARUTOHOODIEGOLDEDITION_Mesadetrabajo1.png?v=1746652796',e:'🍥'},
  {id:'naruto-hoodie',   name:'Hoodie Naruto',         price:25,    variants:['Única'],                                     sizes:['S','M','L','XL','2XL'],      img:'https://cdn.shopify.com/s/files/1/0689/5832/2781/files/HOODIENARUTO_Mesadetrabajo1.png?v=1746652796',e:'🍥'},
  {id:'spider-hoodie',   name:'Hoodie Spiderman',      price:30,    variants:['Rojo'],                                      sizes:['S','M','L','XL','2XL'],      img:'https://cdn.shopify.com/s/files/1/0689/5832/2781/files/NUEVOS1_Mesadetrabajo1.png?v=1746651592',e:'🕷️'},
  {id:'xmen-wolverine',  name:'Hoodie Wolverine',      price:19.99, variants:['Única'],                                     sizes:['S','M','L','XL','2XL'],      img:'https://cdn.shopify.com/s/files/1/0689/5832/2781/files/WOLVERINE-01.png?v=1746661894',e:'🧬'},
  {id:'op-luffy',        name:'Hoodie One Piece',      price:30,    variants:['Rojo','Verde','Beige','Azul marino','Gris'], sizes:['XS','S','M','L','XL','2XL'],img:'https://cdn.shopify.com/s/files/1/0689/5832/2781/files/WhatsAppImage2025-05-07at12.14.16_1.jpg?v=1746736819',e:'⚓'},
  {id:'star-wars',       name:'Chaqueta Star Wars',    price:35,    variants:['Negro'],                                     sizes:['S','M','L','XL','2XL'],      img:'https://cdn.shopify.com/s/files/1/0689/5832/2781/files/star-19.png?v=1747521027',e:'🌌'}
];

const QC=[
  {l:'🐉 Dragon Ball',q:'Dragon Ball'},{l:'⚡ Power Rangers',q:'Power Rangers'},
  {l:'🍥 Naruto',q:'Naruto'},{l:'🕷️ Spider-Man',q:'Spider-Man'},
  {l:'⚓ One Piece',q:'One Piece'},{l:'🌌 Star Wars',q:'Star Wars'},{l:'🧬 X-Men',q:'X-Men'}
];

function ctx(){
  if(window.ShopifyAnalytics&&window.ShopifyAnalytics.meta&&window.ShopifyAnalytics.meta.product){
    var p=window.ShopifyAnalytics.meta.product;
    if(p.title)return p.title;
  }
  if(window.location.href.indexOf('/products/')!==-1){
    var h=document.querySelector('h1');
    if(h&&h.textContent.trim())return h.textContent.trim();
  }
  return '';
}

function sys(){
  var c=ctx();
  return 'Eres Mandi, asistente de ventas de Mandarina Republic Ecuador. Anime streetwear, envío gratis.\n'+
  'REGLA CRÍTICA: Cuando el cliente pide ver productos de una categoría, responde en 1 línea breve y SIEMPRE incluye MOSTRAR_PRODUCTOS:[ids] para mostrar las cards visuales. NUNCA describas productos solo en texto.\n'+
  'CATÁLOGO: dbz-clasic=$35, dbz-goku=$19.99, pr-red=$39.99, pr-white=$39.99, pr-varsity=$35, naruto-chaqueta=$35, naruto-hoodie=$25, spider-hoodie=$30, xmen-wolverine=$19.99, op-luffy=$30, star-wars=$35\n'+
  'FLUJO: 1)pide categoría→responde+MOSTRAR_PRODUCTOS:[ids] 2)elige→pide talla/color 3)pide tel→CAPTURAR_LEAD:[num] 4)confirma→MOSTRAR_PAGO\n'+
  'PAGO: Pichincha 2210996988 / Guayaquil 38180287 / Produbanco 18059046370. Rodrigo Castillo CI 1716608094\n'+
  (c?'CONTEXTO: El cliente ve el producto "'+c+'"':'');
}

var msgs=[],open=false,loading=false,sel=null,stp=null,ord={},unread=0,qrs=false,ld=false,int=null;

function lead(t){
  if(ld)return;ld=true;
  fetch(LEADS,{method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({Telefono:t.replace(/\D/g,''),Pagina:location.href,Producto:int||'',Timestamp:new Date().toISOString(),Fuente:'Mandi Widget'})}).catch(function(){});
  ga('lead_captured',{interest:int||'general'});
}

function injectCSS(){
  var s=document.createElement('style');
  s.textContent=
    '#mw,#mw *{box-sizing:border-box;margin:0;padding:0;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;}'+
    '#mw-btn{position:fixed;bottom:90px;right:20px;z-index:2147483646;width:54px;height:54px;border-radius:50%;background:linear-gradient(135deg,#e8621a,#ff8c00);border:none;cursor:pointer;box-shadow:0 4px 16px rgba(232,98,26,.5);display:flex;align-items:center;justify-content:center;font-size:22px;transition:transform .2s;}'+
    '#mw-btn:hover{transform:scale(1.08);}'+
    '#mw-bdg{position:absolute;top:-3px;right:-3px;background:#ef4444;color:#fff;border-radius:50%;width:18px;height:18px;font-size:10px;font-weight:700;display:none;align-items:center;justify-content:center;}'+
    '#mw-p{position:fixed;bottom:156px;right:20px;z-index:2147483645;width:320px;max-width:calc(100vw - 24px);height:520px;max-height:calc(100vh - 180px);background:#fff;border-radius:16px;overflow:hidden;box-shadow:0 8px 40px rgba(0,0,0,.18);border:1px solid #e5e7eb;display:none;flex-direction:column;}'+
    '#mw-p.on{display:flex;}'+
    '#mw-h{background:linear-gradient(90deg,#e8621a,#ff8c00);padding:12px 14px;display:flex;align-items:center;gap:9px;flex-shrink:0;}'+
    '#mw-av{width:36px;height:36px;border-radius:50%;background:rgba(255,255,255,.25);display:flex;align-items:center;justify-content:center;font-size:18px;flex-shrink:0;}'+
    '#mw-hn{color:#fff;font-weight:700;font-size:14px;line-height:1.2;}'+
    '#mw-hs{color:rgba(255,255,255,.9);font-size:11px;display:flex;align-items:center;gap:4px;margin-top:1px;}'+
    '#mw-dot{width:6px;height:6px;border-radius:50%;background:#4ade80;animation:dp 2s infinite;}'+
    '@keyframes dp{0%,100%{opacity:1}50%{opacity:.3}}'+
    '#mw-x{margin-left:auto;background:rgba(255,255,255,.2);border:none;color:#fff;width:28px;height:28px;border-radius:50%;cursor:pointer;font-size:14px;display:flex;align-items:center;justify-content:center;flex-shrink:0;}'+
    '#mw-m{flex:1;overflow-y:auto;overflow-x:hidden;padding:10px;background:#f3f4f6;display:flex;flex-direction:column;gap:8px;min-height:0;}'+
    '#mw-m::-webkit-scrollbar{width:3px;}'+
    '#mw-m::-webkit-scrollbar-thumb{background:#d1d5db;border-radius:3px;}'+
    // Bot bubble — ancho limitado alineado a la izquierda
    '.mwb{display:flex;width:100%;}'+
    '.mb{max-width:83%;padding:10px 13px;font-size:14px;line-height:1.5;word-break:break-word;white-space:pre-wrap;background:#fff;color:#111;border:1px solid #e5e7eb;border-radius:14px 14px 14px 3px;box-shadow:0 1px 3px rgba(0,0,0,.08);}'+
    '.mt{font-size:10px;margin-top:3px;text-align:right;color:rgba(0,0,0,.3);}'+
    // User bubble — ANCHO COMPLETO, texto blanco
    '.mwu{display:flex;width:100%;}'+
    '.mu{width:100%;padding:10px 14px;font-size:14px;line-height:1.5;word-break:break-word;white-space:pre-wrap;background:#e8621a;color:#fff;border-radius:10px;text-align:left;}'+
    '.mtu{font-size:10px;margin-top:3px;text-align:right;color:rgba(255,255,255,.6);}'+
    // Typing
    '.mtyp{display:flex;gap:4px;align-items:center;background:#fff;border:1px solid #e5e7eb;border-radius:14px;padding:10px 14px;width:fit-content;}'+
    '.md{width:7px;height:7px;border-radius:50%;background:#e8621a;}'+
    '.md:nth-child(1){animation:mb 1.2s 0s infinite}.md:nth-child(2){animation:mb 1.2s .2s infinite}.md:nth-child(3){animation:mb 1.2s .4s infinite}'+
    '@keyframes mb{0%,60%,100%{transform:translateY(0)}30%{transform:translateY(-6px)}}'+
    // Product grid
    '.mpg{display:grid;grid-template-columns:1fr 1fr;gap:8px;width:100%;}'+
    '.mpc{background:#fff;border-radius:10px;border:1px solid #e5e7eb;cursor:pointer;overflow:hidden;display:flex;flex-direction:column;transition:border-color .2s,box-shadow .2s;}'+
    '.mpc:hover{border-color:#e8621a;box-shadow:0 2px 8px rgba(232,98,26,.15);}'+
    '.mpi{width:100%;aspect-ratio:1;object-fit:cover;display:block;}'+
    '.mpb{padding:7px 8px;}'+
    '.mpn{color:#111;font-size:12px;font-weight:700;margin-bottom:2px;line-height:1.3;}'+
    '.mpp{color:#e8621a;font-weight:700;font-size:14px;}'+
    '.mpsb{display:block;width:100%;margin-top:6px;background:#e8621a;color:#fff;border:none;border-radius:6px;padding:6px;font-size:12px;font-weight:600;cursor:pointer;font-family:inherit;}'+
    // Step
    '.mst{background:#fff;border:1px solid #e5e7eb;border-radius:12px;padding:12px;width:100%;}'+
    '.mstt{color:#111;font-size:14px;font-weight:700;margin-bottom:10px;}'+
    '.msbr{display:flex;flex-wrap:wrap;gap:7px;}'+
    '.mob{background:#fff;border:2px solid #e8621a;color:#111;border-radius:8px;padding:8px 14px;cursor:pointer;font-size:14px;font-weight:700;font-family:inherit;transition:all .15s;min-width:44px;text-align:center;}'+
    '.mob:hover,.mob:active{background:#e8621a;color:#fff;}'+
    '.mob.c{border-color:#16a34a;color:#111;}.mob.c:hover{background:#16a34a;color:#fff;}'+
    // Payment
    '.mpay{background:#f0fdf4;border:1px solid #bbf7d0;border-radius:10px;padding:11px;width:100%;}'+
    '.mpayt{color:#15803d;font-weight:700;font-size:13px;margin-bottom:7px;}'+
    '.mbank{background:#fff;border:1px solid #d1fae5;border-radius:7px;padding:7px 9px;margin-bottom:5px;cursor:pointer;}'+
    '.mbank:hover{background:#dcfce7;}'+
    '.mbn{color:#15803d;font-size:12px;font-weight:600;}.mbd{color:#374151;font-size:12px;}'+
    // Lead
    '.mlead{background:#fff;border:1px solid #e5e7eb;border-radius:10px;padding:10px;width:100%;}'+
    '.mlead input{width:100%;background:#f3f4f6;border:1.5px solid #d1d5db;border-radius:8px;padding:8px 10px;color:#111;font-size:14px;outline:none;font-family:inherit;margin-top:5px;}'+
    '.mlead input:focus{border-color:#e8621a;}'+
    '.mlead button{width:100%;margin-top:6px;background:#e8621a;color:#fff;border:none;border-radius:8px;padding:9px;font-size:14px;font-weight:700;cursor:pointer;font-family:inherit;}'+
    // Input bar
    '#mw-ia{background:#fff;padding:9px 11px;display:flex;gap:7px;align-items:center;flex-shrink:0;border-top:1px solid #e5e7eb;}'+
    '#mw-in{flex:1;background:#f3f4f6;border:none;border-radius:20px;padding:9px 14px;color:#111;font-size:14px;outline:none;font-family:inherit;min-width:0;}'+
    '#mw-in::placeholder{color:#9ca3af;}'+
    '#mw-sn{width:36px;height:36px;border-radius:50%;background:#e8621a;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:opacity .2s;}'+
    '#mw-sn:disabled{opacity:.35;cursor:default;}'+
    '#mw-qr{background:#fff;border-top:1px solid #f3f4f6;padding:6px 10px;display:none;flex-direction:column;gap:4px;flex-shrink:0;max-height:190px;overflow-y:auto;}'+
    '#mw-qr.on{display:flex;}'+
    '.mq{background:#fff;border:1.5px solid #e8621a;color:#c44e12;border-radius:8px;padding:7px 12px;cursor:pointer;font-size:13px;font-weight:600;text-align:left;font-family:inherit;transition:all .15s;}'+
    '.mq:hover{background:#e8621a;color:#fff;}'+
    '#mw-pw{text-align:center;font-size:10px;color:#9ca3af;padding:4px;flex-shrink:0;background:#fff;}';
  document.head.appendChild(s);
}

function init(){
  injectCSS();
  var w=document.createElement('div');w.id='mw';
  w.innerHTML=
    '<button id="mw-btn">🍊<span id="mw-bdg"></span></button>'+
    '<div id="mw-p">'+
      '<div id="mw-h"><div id="mw-av">🍊</div><div><div id="mw-hn">Mandarina Republic</div><div id="mw-hs"><span id="mw-dot"></span>Mandi · Asistente</div></div><button id="mw-x">✕</button></div>'+
      '<div id="mw-m"></div>'+
      '<div id="mw-ia"><input id="mw-in" placeholder="Escribe un mensaje..." maxlength="400"><button id="mw-sn" disabled><svg width="15" height="15" viewBox="0 0 24 24" fill="white"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg></button></div>'+
      '<div id="mw-qr"></div>'+
      '<div id="mw-pw">Powered by Mandi IA · mandarinaec.com</div>'+
    '</div>';
  document.body.appendChild(w);
  document.getElementById('mw-btn').onclick=tog;
  document.getElementById('mw-x').onclick=tog;
  var inp=document.getElementById('mw-in');
  inp.oninput=function(){document.getElementById('mw-sn').disabled=!this.value.trim()||loading;};
  inp.onkeydown=function(e){if(e.key==='Enter'&&!e.shiftKey){e.preventDefault();snd();}};
  document.getElementById('mw-sn').onclick=snd;
  var c=ctx();
  bot(c?'Hola! Soy Mandi 🍊\nVeo que estás mirando "'+c+'"\n¿Te ayudo con algo?':'Hola! Soy Mandi 🍊\nAsistente de Mandarina Republic\n¿Qué franquicia te gusta?');
  showQR();
  ga('widget_loaded',{page:location.pathname});
}

function tog(){
  open=!open;
  var p=document.getElementById('mw-p'),b=document.getElementById('mw-bdg');
  if(open){p.classList.add('on');unread=0;b.style.display='none';setTimeout(function(){document.getElementById('mw-in').focus();},80);ga('widget_opened',{page:location.pathname});}
  else p.classList.remove('on');
}

function ts(){return new Date().toLocaleTimeString('es-EC',{hour:'2-digit',minute:'2-digit'});}

function bot(text){
  var m=document.getElementById('mw-m');
  var w=document.createElement('div');w.className='mwb';
  var b=document.createElement('div');b.className='mb';
  b.innerHTML=text.replace(/\n/g,'<br>')+'<div class="mt">'+ts()+'</div>';
  w.appendChild(b);m.appendChild(w);m.scrollTop=m.scrollHeight;
  if(!open){unread++;var bd=document.getElementById('mw-bdg');bd.style.display='flex';bd.textContent=unread>9?'9+':String(unread);}
  msgs.push({role:'assistant',content:text});
}

function usr(text){
  var m=document.getElementById('mw-m');
  var w=document.createElement('div');w.className='mwu';
  var b=document.createElement('div');b.className='mu';
  b.innerHTML=text.replace(/\n/g,'<br>')+'<div class="mtu">'+ts()+'</div>';
  w.appendChild(b);m.appendChild(w);m.scrollTop=m.scrollHeight;
  msgs.push({role:'user',content:text});
}

function addEl(el){var m=document.getElementById('mw-m');m.appendChild(el);m.scrollTop=m.scrollHeight;}

function showTyp(){
  var m=document.getElementById('mw-m'),e=document.createElement('div');
  e.className='mwb';e.id='mw-typ';
  e.innerHTML='<div class="mtyp"><div class="md"></div><div class="md"></div><div class="md"></div></div>';
  m.appendChild(e);m.scrollTop=m.scrollHeight;
}
function hideTyp(){var e=document.getElementById('mw-typ');if(e)e.remove();}

function showQR(){
  if(qrs)return;qrs=true;
  var qr=document.getElementById('mw-qr');qr.innerHTML='';
  QC.forEach(function(c){
    var b=document.createElement('button');b.className='mq';b.textContent=c.l;
    b.onclick=function(){hideQR();send('Quiero ver '+c.q);};
    qr.appendChild(b);
  });
  qr.classList.add('on');
}
function hideQR(){var q=document.getElementById('mw-qr');q.classList.remove('on');q.innerHTML='';}

function renderProds(prods){
  var grid=document.createElement('div');grid.className='mpg';
  prods.forEach(function(p){
    var card=document.createElement('div');card.className='mpc';
    var img=document.createElement('img');img.className='mpi';img.src=p.img;img.alt=p.name;img.loading='lazy';
    img.onerror=function(){this.style.display='none';};
    var info=document.createElement('div');info.className='mpb';
    var nm=document.createElement('div');nm.className='mpn';nm.textContent=p.e+' '+p.name;
    var pr=document.createElement('div');pr.className='mpp';pr.textContent='$'+p.price;
    var sb=document.createElement('button');sb.className='mpsb';sb.textContent='Lo quiero 🛒';
    sb.onclick=function(e){e.stopPropagation();selProd(p);};
    info.appendChild(nm);info.appendChild(pr);info.appendChild(sb);
    card.appendChild(img);card.appendChild(info);
    card.onclick=function(){selProd(p);};
    grid.appendChild(card);
    ga('product_viewed',{id:p.id,value:p.price});int=p.name;
  });
  addEl(grid);
}

function renderLead(){
  if(ld)return;
  var box=document.createElement('div');box.className='mlead';
  box.innerHTML='<div style="color:#111;font-size:13px;font-weight:600">📲 ¿A qué WhatsApp te avisamos?</div><input id="mw-ph" type="tel" placeholder="09XXXXXXXX" maxlength="15"><button id="mw-phs">Confirmar número</button>';
  addEl(box);
  document.getElementById('mw-phs').onclick=function(){
    var t=document.getElementById('mw-ph').value.trim();
    if(t.length<7)return;
    lead(t);box.remove();bot('Perfecto! Te contactamos al '+t+' 🍊');
  };
}

function selProd(p){sel=p;stp='size';int=p.name;bot('¡Buena elección! '+p.e+' '+p.name+' — $'+p.price);ga('product_selected',{id:p.id,value:p.price});renderStep();}

function renderStep(){
  var old=document.getElementById('mw-step');if(old)old.remove();
  var box=document.createElement('div');box.className='mst';box.id='mw-step';
  if(stp==='size'){
    box.innerHTML='<div class="mstt">📏 ¿Qué talla necesitas?</div><div class="msbr"></div>';
    sel.sizes.forEach(function(s){
      var b=document.createElement('button');b.className='mob';b.textContent=s;
      b.onclick=function(){ord.size=s;stp=sel.variants.length>1?'color':'confirm';if(stp==='confirm')ord.color=sel.variants[0];renderStep();};
      box.querySelector('.msbr').appendChild(b);
    });
  }else if(stp==='color'){
    box.innerHTML='<div class="mstt">🎨 ¿Qué color prefieres?</div><div class="msbr"></div>';
    sel.variants.forEach(function(v){
      var b=document.createElement('button');b.className='mob c';b.textContent=v;
      b.onclick=function(){ord.color=v;stp='confirm';renderStep();};
      box.querySelector('.msbr').appendChild(b);
    });
  }else if(stp==='confirm'){
    box.innerHTML=
      '<div class="mstt">✅ Resumen del pedido</div>'+
      '<div style="background:#f8f9fa;border-radius:8px;padding:10px;font-size:13px;color:#374151;line-height:1.9">'+
        '<b style="color:#111">'+sel.name+'</b><br>'+
        'Talla: <b style="color:#111">'+ord.size+'</b>&nbsp;|&nbsp;Color: <b style="color:#111">'+ord.color+'</b><br>'+
        'Total: <b style="color:#e8621a;font-size:18px">$'+sel.price+'</b>'+
      '</div>'+
      '<div style="display:flex;gap:8px;margin-top:10px">'+
        '<button class="mpsb" id="mw-ok" style="flex:1;border-radius:8px;padding:9px;font-size:13px">Confirmar pedido ✓</button>'+
        '<button id="mw-no" style="background:#f3f4f6;color:#6b7280;border:none;border-radius:8px;padding:9px 12px;cursor:pointer;font-size:13px;font-family:inherit">Cancelar</button>'+
      '</div>';
    box.querySelector('#mw-ok').onclick=confirmOrd;
    box.querySelector('#mw-no').onclick=function(){box.remove();sel=null;stp=null;ord={};bot('Sin problema. ¿Quieres ver otra opción?');};
  }
  addEl(box);
}

function confirmOrd(){
  var msg='Confirmo: '+sel.name+', talla '+ord.size+', color '+ord.color+'. $'+sel.price;
  ga('purchase_intent',{product:sel.name,value:sel.price});
  sel=null;stp=null;ord={};
  var s=document.getElementById('mw-step');if(s)s.remove();
  send(msg);
  if(!ld)setTimeout(renderLead,1500);
}

function renderPay(){
  var box=document.createElement('div');box.className='mpay';
  box.innerHTML='<div class="mpayt">💳 Datos para transferencia</div>'+
    [{n:'Banco Pichincha',a:'2210996988'},{n:'Banco Guayaquil',a:'38180287'},{n:'Produbanco',a:'18059046370'}].map(function(b){
      return '<div class="mbank" onclick="navigator.clipboard.writeText(\''+b.a+'\').catch(function(){});"><div class="mbn">'+b.n+'</div><div class="mbd">'+b.a+' · Rodrigo Castillo</div></div>';
    }).join('')+
    '<div style="font-size:11px;color:#9ca3af;text-align:center;margin-top:6px">Toca para copiar · Comprobante por WhatsApp</div>';
  addEl(box);ga('payment_info_shown');
}

function snd(){
  var inp=document.getElementById('mw-in'),t=inp.value.trim();
  if(!t||loading)return;inp.value='';document.getElementById('mw-sn').disabled=true;
  send(t);
}

function send(text){
  hideQR();usr(text);ga('message_sent',{count:msgs.length});loading=true;showTyp();
  fetch(PROXY,{method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({system:sys(),messages:msgs.map(function(m){return{role:m.role,content:m.content};})})})
  .then(function(r){return r.json();})
  .then(function(data){
    var raw=(data.content&&data.content[0]&&data.content[0].text)||'Lo siento, intenta de nuevo.';
    var pay=false;
    if(raw.indexOf('MOSTRAR_PAGO')!==-1){pay=true;raw=raw.replace(/MOSTRAR_PAGO/g,'').trim();}
    if(raw.indexOf('ESCALAR_HUMANO')!==-1){raw=raw.replace(/ESCALAR_HUMANO/g,'').trim()+'\n\n👉 wa.me/593983745757';}
    var lm=raw.match(/CAPTURAR_LEAD:\[([^\]]+)\]/);if(lm){lead(lm[1]);raw=raw.replace(/CAPTURAR_LEAD:\[[^\]]+\]/g,'').trim();}
    var pm=raw.match(/MOSTRAR_PRODUCTOS:\[([^\]]+)\]/);var pids=[];
    if(pm){pids=pm[1].split(',').map(function(s){return s.trim();});raw=raw.replace(/MOSTRAR_PRODUCTOS:\[[^\]]+\]/g,'').trim();}
    hideTyp();
    if(raw)bot(raw);
    if(pay)renderPay();
    if(pids.length>0){var found=CAT.filter(function(p){return pids.indexOf(p.id)!==-1;});if(found.length>0)renderProds(found);}
    loading=false;document.getElementById('mw-sn').disabled=false;
  }).catch(function(){hideTyp();bot('Error de conexión. Escríbenos por WhatsApp.');loading=false;document.getElementById('mw-sn').disabled=false;});
}

if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();
